import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLightningBolt: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconLightningBolt"><Path d="M6 13.5L14 3.5L13 10.5H18L10 20.5L11 13.5H6Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconLightningBolt;
